<template>
    <transition :css="false" @enter="intro" @leave="outro">
        <router-link
            :to="to"
            class="IconBttn"
            @mouseenter.native="onMouseEnter"
            @mouseleave.native="onMouseLeave"
            @click.native="$emit('click', $event)"
        >
            <line-icon
                v-show="visible"
                :d="iconPath"
                :width="iconWidth"
                :height="iconHeight"
                :dark="dark"
                :hovered="hovered"
            ></line-icon>
            <text-transition>
                <small v-show="visible" class="IconBttn-text">
                    <slot></slot>
                </small>
            </text-transition>
        </router-link>
    </transition>
</template>

<script>
import TextTransition from '../transitions/TextTransition'
import LineIcon from './LineIcon'
export default {
    name: 'IconBttn',
    props: {
        to: {
            type: [Object, String],
            required: true,
        },
        iconPath: {
            type: String,
            required: true,
        },
        iconWidth: {
            type: Number,
        },
        iconHeight: {
            type: Number,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        dark: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        LineIcon,
        TextTransition,
    },
    data() {
        return {
            visible: false,
            hovered: false,
        }
    },
    methods: {
        intro($el, done) {
            this.visible = true
            TweenLite.delayedCall(0.75, done)
        },
        outro($el, done) {
            this.visible = false
            TweenLite.delayedCall(0.75, done)
        },
        onMouseEnter() {
            this.hovered = true
        },
        onMouseLeave() {
            this.hovered = false
        },
    },
    computed: {
        modifiers() {
            const { dark } = this
            return {
                'IconBttn--dark': dark,
            }
        },
    },
}
</script>

<style src="styles/components/IconBttn.styl" lang="stylus"></style>


// WEBPACK FOOTER //
// src/app/components/IconBttn.vue